import { CCardInterface } from '../types';
import { get, post } from './axios';

const URLS = {
  addCCard: 'add-cl-ccard',
  updateCCard: 'update-cl-ccard',
  deleteCCard: 'del-cl-ccard',
  getClAccounts: 'get-cl-accounts'
};

const cardsApi = {
  addCCard: (card: CCardInterface) => post(URLS.addCCard, card),
  updateCCard: (card: Partial<CCardInterface>) => post(URLS.updateCCard, card),
  deleteCCard: (cardId: number) => get(URLS.deleteCCard, { ccardid: cardId }),
  getClAccounts: () => get(URLS.getClAccounts)
};

export default cardsApi;
